import React from "react";
import HirePageBanner from "../components/HirePageBanner/HirePageBanner";
import CustomSoftware from "../components/custom-software/CustomSoftware";
import DevelopmentPerformance from "../components/DevelopmentPerformance/DevelopmentPerformance";
import GuaranteedResults from "../components/guaranteed-results/GuaranteedResults";
import SecondFaq from "../components/secondFaq/SecondFaq";
import Footer from "../components/footer/Footer";
import MegaHeader from "../components/MegaHeader/MegaHeader";
import { Helmet } from "react-helmet";
import {
  bannerList,
  facts,
  faqData,
  hireReactPageContent,
  mainBannerImg,
  reactFaqContentEn,
  servicesData,
  softwareCompanyCtaReact,
  solutionsData,
  steps,
  tabItems,
  tabs,
  techCombinations,
} from "../data/hire-reactjs-data";
import HirePageExperties from "../components/hirepageExperties/HirePageExperties";
import HirePageSteps from "../components/hire-page-steps/HirePageSteps";
import HireExpertFacts from "../components/hire-expert-facts/HireExpertFacts";
import HirePageAppIdea from "../components/hire-page-app-idea/HirePageAppIdea";
import HirePageEngagmentModels from "../components/hire-page-engagment-models/HirePageEngagmentModels";
import ContactSection from "../components/contactSection/ContactSection";
import TrendsInsights from "../components/trends-n-insights/TrendsInsights";
import HireCombinationSection from "../components/hire-combination-sectiono/HireCombinationSection";
import CoverTheStack from "../components/coverthestack/CoverTheStack";
import { useTranslation } from "react-i18next";
import SoftwareCompanyCta from "../components/software-company-cta/SoftwareCompanyCta";
import SimpleModels from "../components/simpleEngagementModels";
import MegaMenu from "../components/MegaMenu/MegaMenu";
import OurServices from "../components/our-services/OurServices";
import ServicesPageBanner from "../components/services-page-banner/ServicesPageBanner";
import TrustedPartner from "../components/trustedPartners/TrustedPartner";
import NewTestimonials from "../components/new-testimonials/NewTestimonials";
import WhyChooseUs from "../components/why-choose-us/WhyChooseUs";
import NewCaseStudySection from "../components/new-case-study-section/NewCaseStudySection";

const HireReact = () => {
  const { t } = useTranslation("hireReactPage");
  const bannerData = t("bannerData", { returnObjects: true });
  const servicesSection = t("servicesData", { returnObjects: true });
  const solutionSection = t("solutionData", { returnObjects: true });
  const combinationSection = t("combinationData", { returnObjects: true });
  const stepsSection = t("stepsData", { returnObjects: true });
  const coverTheStackSection = t("coverTheStackData", { returnObjects: true });
  const factSection = t("factsData", { returnObjects: true });
  const appIdeaData = t("appIdeaData", { returnObjects: true });
  const engagementModelData = t("pageEngagmentModels", { returnObjects: true });
  const faqSection = t("faqData", { returnObjects: true });
  const mainBannerImg = t("mainBannerImgData", { returnObjects: true });

  const { t: tmetaTitles } = useTranslation("metaTitles");
  const metaTitle = tmetaTitles("hireReactTitle", { returnObjects: false });

  const { t: tengagementModelContent } = useTranslation(
    "engagementModelContent"
  );

  // grab the full object once
  const engagementModelsContent = {
    heading: tengagementModelContent("heading"),
    darkHeading: tengagementModelContent("darkHeading"),
    subheading: tengagementModelContent("subheading"),
    models: tengagementModelContent("models", { returnObjects: true }),
    cta: tengagementModelContent("cta", { returnObjects: true }),
  };

  const { t: tfooter } = useTranslation("footer");
  const footerCtaContent = tfooter("footerCtaContent", {
    returnObjects: true,
  });
  return (
    <>
      <Helmet>
        <title>Hire React JS Developers | Top React Engineers Available in Just 24 Hours</title>
        <meta
          name="description"
          content="Build high-performance web apps and SaaS products with top React JS developers from Bitsclan. Hire US-based React experts for stunning user experiences, fast launches, and robust architecture."
        />
      </Helmet>

      <MegaMenu />

      <ServicesPageBanner
        shortHeading={bannerData?.shortHeading}
        mainHeading={bannerData?.mainHeading}
        description={bannerData?.content}
      />
      <TrustedPartner />

      <OurServices
        mainHeading={servicesSection?.mainHeading}
        description={servicesSection?.sectionDescription}
        servicesCardsData={servicesSection?.services}
        buttonText={servicesSection?.buttonText}
      />

      <NewTestimonials shortHeading="Awesome Clients Reviews"
        mainHeading="Transformative <span>React Solutions</span> Hear from Our Clients"
        description="The good words from our clients about our expert react development services, inspire us to continue delivering excellence, combining technical expertise with dependable service for long-term growth & success." />

      <WhyChooseUs
        shortHeading="Why Hire React JS Developers From Bitsclan?"
        greenHeading="Leverage Expertise "
        heading="Drive Innovation Hire React Developers Who Deliver"
        content="At Bitsclan, our ReactJS experts deliver precise, timely solutions for startups, SMEs, enterprises, & executives. From consultation to custom apps, we build lightweight, interactive applications powered by robust React libraries & proven development expertise."
        stats={[
          // {
          //   number: "2017",
          //   title: "React Services Since",
          // },
          {
            number: "140+",
            title: "React Success Stories",
          },
          {
            number: "100+",
            title: "ReactJS Engineers",
          },
          {
            number: "14+",
            title: "React Solutions Industries",
          },
        ]}
      />

      {/* <DevelopmentPerformance
        heading={solutionSection?.mainHeading}
        greenHeading={solutionSection?.greenHeading}
        subHeading={solutionSection?.sectionDescription}
        solutions={solutionSection?.solutions}
        buttonText={solutionSection?.buttonText}
      /> */}

      <NewCaseStudySection
        shortHeading="Our React Development Brilliant Work"
        heading="Showcasing Success Our <span>React Solutions</span> Empowering Global Businesses"
        description="See the React projects we built for partners worldwide. Each solution reflects innovation, strong performance, & results that empower businesses with reliable & modern applications."
      />

      <HireCombinationSection
        shortHeading="Powerful Technology Combinations Our React JS Developers Use"
        combinations={combinationSection?.combinations}
        heading={combinationSection?.heading}
        description={combinationSection?.description}
      />

      <HirePageSteps
        heading={stepsSection?.heading}
        subHeading={stepsSection?.subHeading}
        steps={stepsSection?.steps}
        buttonText={stepsSection?.buttonText}
      />

      <CoverTheStack
        shortHeading="React Technologies We Use"
        whereStart={coverTheStackSection?.whereStart}
        mainHeading={coverTheStackSection?.mainHeading}
        subHeading={coverTheStackSection?.subHeading}
        tabs={coverTheStackSection?.tabs}
        tabItems={coverTheStackSection?.tabItems}
      />

      <HireExpertFacts
        heading={factSection?.hading}
        greenHeading={factSection?.greenHeading}
        facts={factSection?.facts}
        diffBannerBackgroundImage={mainBannerImg?.factBackgroundImage}
        buttonText={factSection?.buttonText}
      />

      {/* <HirePageAppIdea
        heading={appIdeaData?.heading}
        content={appIdeaData?.sectionDescription}
      /> */}

      {/* <HirePageEngagmentModels
        heading={engagementModelData?.headingContent}
        content={engagementModelData?.discription}
        hiringDetails={engagementModelData?.hiringDetails}
        buttonText={engagementModelData?.buttonText}
      /> */}

      {/* <SimpleModels content={engagementModelsContent} /> */}

      <TrendsInsights heading="Key Insights From Our React Development Experts" description="Read trending insights from our React development experts, offering guidance on delivering great customer experiences, strengthening engagement, & creating customer-focused digital solutions that help businesses grow through innovative React-driven technology." specificClass="mobile-dev-page" category="all" />

      <SecondFaq
        faqs={reactFaqContentEn?.faqData}
        specificClass="mobile-dev-page"
        mainHeading={reactFaqContentEn?.mainHeading}
      />

      {/* <ContactSection /> */}

      <SoftwareCompanyCta content={softwareCompanyCtaReact} />

      <Footer />
    </>
  );
};

export default HireReact;
